export const NEW_PATH = '/runbooks/new/'
export const LIST_PATH = '/runbooks/'
export const TEMPLATES_PATH = '/templates/'
export const TEMPLATE_DETAIL_PATH = '/templates/:templateId/'
export const DETAIL_PATH = '/runbooks/:id/'
export const GRAPH_PATH = '/runbooks/graph/:id/'
export const TEAM_PATH = '/team/'
export const CMDB_SOLUTIONS_PATH = '/cmdb/solutions/'
export const CMDB_DEVICES_PATH = '/cmdb/devices/'
export const CMDB_CONTACTS_PATH = '/cmdb/contacts/'
export const CONTACTS_PATH = '/contacts/'
export const DOCUMENTATION_PATH = '/documentation/'
export const CMDB_STATUS_PATH = '/cmdb/status/'
export const LOGOUT_PATH = '/logout/'
